import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "onChange"],
  _excluded2 = ["state", "countdown", "buttonProps", "sendCode"];
import { Button, Input } from "@pionex-web-kit/components";
import React, { useMemo } from "react";
import { State } from "trade_utils_lib";
import { useTranslators } from "../hooks/Locale";
import { jsx as _jsx } from "react/jsx-runtime";
export function InputWithOnlyNumber(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Input, _objectSpread({
    value: value !== null && value !== void 0 ? value : "",
    onChange: function onChange(e) {
      if (/^[0-9]*$/.test(e.target.value) || e.target.value === "") {
        _onChange && _onChange(e);
      }
    }
  }, inputProps));
}
export var CodeInput = function CodeInput(props) {
  var state = props.state,
    countdown = props.countdown,
    buttonProps = props.buttonProps,
    sendCode = props.sendCode,
    inputProps = _objectWithoutProperties(props, _excluded2);
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var buttonText = useMemo(function () {
    if (state === State.ING) {
      return $st("balance_withdraw_sending");
    } else if (state === State.UNKNOWN) {
      return $st("account_verify_code_send");
    } else if (countdown <= 0) {
      return $st("withdraw.confirmation.phone.code.resend");
    } else {
      return "".concat(countdown, "s");
    }
  }, [state, countdown, $st]);
  return /*#__PURE__*/_jsx(InputWithOnlyNumber, _objectSpread({
    suffix: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      loading: state === State.ING,
      disabled: state === State.ING || state === State.DONE && countdown > 0,
      type: "primary",
      size: "small",
      onClick: sendCode
    }, buttonProps), {}, {
      children: buttonText
    })),
    placeholder: $st("sign_up_hint_verification_code"),
    size: "large"
  }, inputProps));
};